import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=3cc583d8&scoped=true&"
import script from "./activity.vue?vue&type=script&lang=ts&"
export * from "./activity.vue?vue&type=script&lang=ts&"
import style0 from "./activity.vue?vue&type=style&index=0&id=3cc583d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc583d8",
  null
  
)

export default component.exports